export default __webpack_public_path__ + "static/media/footerImage2.13f89618.png";